import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const ARM_Addressing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="ARM Addressing Modes & Instruction Set"
      videos={[
        "https://www.youtube.com/embed/lS5DqK7a3cY", // ARM addressing overview
        "https://www.youtube.com/embed/TUCAnDT-5Yc", // Engineering Funda addressing modes
        "https://www.youtube.com/embed/sBY9hu_pltg"  // Instruction set basics
      ]}
      takeaways={[
        {
          text: "ARM7 supports 7 addressing modes including immediate, register, and various indirect modes crucial for efficient memory access[2][5]."
        },
        {
          text: "Conditional execution uses CPSR flags (N,Z,C,V) updated by ALU operations with 'S' suffix instructions[7][9][12]."
        },
        {
          text: "Load-store architecture uses 3-address format for data processing instructions with 32-bit fixed-length encoding[4][6]."
        }
      ]}
      questions={[
        "Explain any 10 condition attributes (condition execution) that controls whether or not the ARM core will execute an instruction.",
        "Explain with examples the different addressing modes for single register Load-store ARM instructions.",
        "Discuss the function performed in the ARM Processor by this instruction ADD r3,r5,r12",
        "Use the ARM instruction set of ARM7 TDMI and write a code to get three times of value/data in R1 as the result.",
        "Write a simple ARM program to find y=x²+3x+5 where x is input stored in r0 register",
        "Provide a concise overview of the data processing instructions available for ARM processors.",
        "Discuss the different addressing modes for single register Load-store instructions of ARM 7 microprocessors.",
        "Draw the CPSR register contents of the ARM 7 processor and explain condition flags updated by ALU operations[9][11]."
      ]}
      exampleVideos={[]}
    />
  );
}

export default ARM_Addressing;
